export const setWindowLocation = (url) => {
    window.location.href = url;
};
